import { postWithTokenV2, getWithToken } from 'api/network';
import { put, takeEvery } from 'redux-saga/effects';
import {
  appNotify,
  publishAssumptionGroup,
  setErrorListModalState,
  setSelectedGroup,
  setSelectedModule
} from '../../../store/actions';

export function* publishAssumptionGroupSaga() {
  yield takeEvery(publishAssumptionGroup, function* ({ payload }) {
    try {
      const { selectedGroup } = payload

      const requestBody = {
        assumptionGroupId: selectedGroup.groupId
      }

      const url = `/api/assumptions/publish`;
      const publishedResponse = yield postWithTokenV2(url, requestBody);

      const updatedGroup = {
        ...selectedGroup,
        wasPublished: true,
        publishedOn: publishedResponse.publishedOn
      }

      yield put(setSelectedGroup(updatedGroup));

      const moduleUrl = `/api/assumptions/modules/${selectedGroup.moduleId}`;
      const res = yield getWithToken(moduleUrl);
      const data = yield res.json();

      yield put(setSelectedModule(data));

      yield put(appNotify(`publish successful`, 'success'));
    } catch (error) {
      var { details } = error;
      if (!details) {
        yield put(
          appNotify(`Failed to publish assumption group: ${error.message}`, 'error')
        );
      }
      if (details.length === 1) {
        var [firstDetails] = details;
        yield put(appNotify(firstDetails, 'error'));
        return;
      }

      yield put(setErrorListModalState({ header: 'Unable to publish for the following reasons', details }))
      const options = {
        showDetailsButton: true
      }

      yield put(appNotify('Unable to publish', 'error', options));
    }
  });
}
